var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"library padded"},[_c('h2',[_vm._v("Библиотека")]),(_vm.Id)?_c('i-list-editor',{attrs:{"scheme":_vm.scheme,"value":_vm.lib},on:{"save":_vm.save}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }